// =============================================
// SERVICIO DE PORTAL DE PROPIETARIOS
// =============================================

import api from './api';

const ownerPortalService = {
  // Obtener dashboard del propietario
  getDashboard: async () => {
    const response = await api.get('/owner-portal/dashboard');
    return response.data;
  },

  // Obtener historial de pagos
  getPayments: async (year = null) => {
    const params = year ? { year } : {};
    const response = await api.get('/owner-portal/payments', { params });
    return response.data;
  },

  // Obtener estado de cuenta detallado
  getStatement: async (filters = {}) => {
    const response = await api.get('/owner-portal/statement', { params: filters });
    return response.data;
  },

  // Obtener gastos del condominio
  getExpenses: async (filters = {}) => {
    const response = await api.get('/owner-portal/expenses', { params: filters });
    return response.data;
  },
};

export default ownerPortalService;
